export default __webpack_public_path__ + "assets/images/9a24b5ad35891f3dd73e5769bd6452de.png";